import { Loader, LoaderStatus } from "@googlemaps/js-api-loader";

import { sleep } from "../utils";

export class GoogleMapsService {
	private static isRunInit = false;
	private static isInitialized = false;
	private static loader: Loader;
	private static mapsLibrary: google.maps.MapsLibrary;
	private static placesLibrary: google.maps.PlacesLibrary;
	private static markerLibrary: google.maps.MarkerLibrary;
	private static elevationLibrary: google.maps.ElevationLibrary;

	static init() {
		if (this.isRunInit) {
			return;
		}
		this.isRunInit = true;

		if (!process.env.REACT_APP_GOOGLE_MAPS_API_KEY) {
			return;
		}

		this.loader = new Loader({
			libraries: ["places", "maps", "marker"],
			apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
			id: "google-maps",
			version: "weekly",
		});
		this.isInitialized = true;
	}

	static async loadElevation(): Promise<google.maps.ElevationLibrary> {
		if (!this.isRunInit) {
			this.init();
		} else if (!this.isInitialized) {
			await sleep();
			return await this.loadElevation();
		}

		if (!this.elevationLibrary) {
			if (this.loader.status === LoaderStatus.LOADING) {
				await sleep();
			}
			this.elevationLibrary = await this.loader.importLibrary("elevation");
		}

		return this.elevationLibrary;
	}

	static async loadMaps(): Promise<google.maps.MapsLibrary> {
		if (!this.isRunInit) {
			this.init();
		} else if (!this.isInitialized) {
			await sleep();
			return await this.loadMaps();
		}

		if (!this.mapsLibrary) {
			if (this.loader.status === LoaderStatus.LOADING) {
				await sleep();
			}
			this.mapsLibrary = await this.loader.importLibrary("maps");
		}

		return this.mapsLibrary;
	}

	static async loadMarker(): Promise<google.maps.MarkerLibrary> {
		if (!this.isRunInit) {
			this.init();
		} else if (!this.isInitialized) {
			await sleep();
			return await this.loadMarker();
		}

		if (!this.markerLibrary) {
			if (this.loader.status === LoaderStatus.LOADING) {
				await sleep();
			}
			this.markerLibrary = await this.loader.importLibrary("marker");
		}

		return this.markerLibrary;
	}

	static async loadPlaces(): Promise<google.maps.PlacesLibrary> {
		if (!this.isRunInit) {
			this.init();
		} else if (!this.isInitialized) {
			await sleep();
			return await this.loadPlaces();
		}

		if (!this.placesLibrary) {
			if (this.loader.status === LoaderStatus.LOADING) {
				await sleep();
			}
			this.placesLibrary = await this.loader.importLibrary("places");
		}

		return this.placesLibrary;
	}
}
